export const AMOUNT_UNIT = {
  WON: 'WON',
  THOUSAND: 'THOUSAND',
  MILLION: 'MILLION',
};

export const DEFAULT_AMOUNT_UNIT = AMOUNT_UNIT.THOUSAND;

export const AMOUNT_UNIT_OPTIONS = [
  { value: AMOUNT_UNIT.WON, name: '원' },
  { value: AMOUNT_UNIT.THOUSAND, name: '천원' },
  { value: AMOUNT_UNIT.MILLION, name: '백만원' },
];

export const getAmountUnitDivisor = (unit = DEFAULT_AMOUNT_UNIT) => {
  switch (unit) {
    case AMOUNT_UNIT.WON:
      return 1;
    case AMOUNT_UNIT.MILLION:
      return 1000000;
    case AMOUNT_UNIT.THOUSAND:
    default:
      return 1000;
  }
};

export const getAmountUnitLabel = (unit = DEFAULT_AMOUNT_UNIT) => {
  const found = AMOUNT_UNIT_OPTIONS.find((item) => item.value === unit);
  return found?.name ?? '천원';
};

export const toBudgetDisplayAmount = (
  value,
  unit = DEFAULT_AMOUNT_UNIT
) => {
  const num =
    typeof value === 'number'
      ? value
      : Number(String(value ?? '').replace(/,/g, ''));
  if (isNaN(num)) return 0;

  const divisor = getAmountUnitDivisor(unit);
  if (divisor === 1) return Math.round(num);

  return Math.round((num / divisor) * 100) / 100;
};

export const formatBudgetAmount = (value, unit = DEFAULT_AMOUNT_UNIT) => {
  if (value == null || value === '') return '0';

  const display = toBudgetDisplayAmount(value, unit);
  if (Number.isInteger(display)) {
    return display.toLocaleString('ko-KR');
  }

  return display.toLocaleString('ko-KR', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  });
};

export const parseBudgetAmountInput = (
  newValue,
  unit = DEFAULT_AMOUNT_UNIT
) => {
  const cleaned = String(newValue ?? '').replace(/,/g, '').trim();
  if (!cleaned) return 0;

  const parsed = parseFloat(cleaned);
  if (isNaN(parsed)) return 0;

  return Math.round(parsed * getAmountUnitDivisor(unit));
};

export const createBudgetAmountFormatter = (unit = DEFAULT_AMOUNT_UNIT) => {
  return (params) => formatBudgetAmount(params.value, unit);
};

export const createBudgetAmountParser = (unit = DEFAULT_AMOUNT_UNIT) => {
  return (params) => parseBudgetAmountInput(params.newValue, unit);
};
